<footer class="ami-footer">
      <div class="footer-logo">
        <img src="/assets/imgs/logos/AmiLearn-Logo_Vertical_Reverse.svg" width="130" alt="White AmiLearn logo" title="AmiLearn's logo">
      </div>
      <div class="footer-social">
        <h5>Connect</h5>
        <a href="https://www.amilearn.ca" role="link" target="_blank">www.amilearn.ca</a>
        <ul>
          <li>
            <a href="https://twitter.com/meet_ami" role="link" target="_blank">
              <picture>
                <source type="image/webp" srcset="/assets/imgs/icons/Twitter-icon_Reverse.webp">
                <source type="image/png" srcset="/assets/imgs/icons/Twitter-icon_Reverse.png">
                <img type="image/png" src="/assets/imgs/icons/Twitter-icon_Reverse.png" width="25" alt="White Twitter bird icon" title="Visit us on Twitter">
              </picture>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/meetami-innovations-inc/" role="link" target="_blank">
              <picture>
                <source type="image/webp" srcset="/assets/imgs/icons/LinkedIn-icon_In_Reverse.webp">
                <source type="image/png" srcset="/assets/imgs/icons/LinkedIn-icon_In_Reverse.png">
                <img type="image/png" src="/assets/imgs/icons/LinkedIn-icon_In_Reverse.png" width="25" alt="White LinkedIn icon" title="Visit us on LinkedIn">
              </picture>
            </a>
          </li>
          <li>
            <a href="mailto:info@amilearn.ca" 
            role="link"
            (click)="contactInfoClick()">
              <picture>
                <source type="image/webp" srcset="/assets/imgs/icons/Mail-icon_Reverse.webp">
                <source type="image/png" srcset="/assets/imgs/icons/Mail-icon_Reverse.png">
                <img type="image/png" src="/assets/imgs/icons/Mail-icon_Reverse.png" width="36" alt="White email icon" title="Contact us">
              </picture>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-contact">
        <ul>
          <li>
            <a href="https://amilearn.ca/terms/" role="link" target="_blank">Terms and Conditions</a>
          </li>
          <li>
            <a href="mailto:support@meetami.ca" 
            role="link"
            (click)="contactSupportClick()">
            Contact Support
          </a>
          </li>
        </ul>
      </div>

      <div class="footer-disclaimer">
        <object data="/assets/imgs/logos/MeetAmi-Logo_Horizontal_Reverse.svg" width="240" height="24" aria-label="Meetami's logo, AmiLearn's parent company"></object>
        <p>
          © 2024 MeetAmi Innovations Inc. All rights reserved.
          AmiLearn, AmiPro, AmiServices, and AmiShelf are trademarks of MeetAmi Innovations Inc.
        </p>
      </div>
</footer>
